<template>
    <div data-cy="date-of-birth">
        <div class="dob-wrapper">
            <template v-for="part in dobParts">
                <component
                    :is="`dob${capitalize(part)}`"
                    :key="part"
                    v-model="dob[part]"
                    :has-error="hasError"
                    :disabled="disabled"
                />
            </template>
        </div>
        <p v-show="hasError" class="help-block">
            {{ $t('error.input.not-valid-dob') }}
        </p>
    </div>
</template>

<script>
import dobDay from './dob-day-select';
import dobMonth from './dob-month-select';
import dobYear from './dob-year-select';

export default {
    name: 'FormDOB',
    introduction: 'Date Of Birthday selector component',
    components: {
        dobDay,
        dobMonth,
        dobYear,
    },
    props: {
        hasError: {
            type: Boolean,
            default: false,
            note: 'Checking error state',
        },
        disabled: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            dob: {
                day: null,
                month: null,
                year: null,
            },
        };
    },
    computed: {
        dobParts() {
            if (typeof Intl.DateTimeFormat.prototype.formatToParts !== 'function') {
                switch (this.$i18n.locale) {
                    case 'en':
                        return ['month', 'day', 'year'];
                    case 'zh':
                    case 'ja':
                        return ['year', 'month', 'day'];
                    default:
                        return ['day', 'month', 'year']; // europe, thai and russia
                }
            } else {
                return Intl.DateTimeFormat(this.$i18n.locale)
                    .formatToParts()
                    .map((x) => x.type)
                    .filter((x) => x !== 'literal');
            }
        },
    },
    watch: {
        dob: {
            deep: true,
            handler() {
                if (this.dob.day && this.dob.month && this.dob.year) {
                    this.$emit(
                        'input',
                        `${this.dob.year}${this.dob.month
                            .toString()
                            .padStart(2, '0')}${this.dob.day.toString().padStart(2, '0')}`
                    );
                }
            },
        },
    },
    methods: {
        capitalize(value) {
            return value.charAt(0).toUpperCase() + value.slice(1);
        },
    },
};
</script>

<style lang="less">
.dob-wrapper {
    margin-bottom: 10px;
    display: flex;
    justify-content: space-between;
    > span {
        line-height: 50px;
    }
    .form-group {
        margin-bottom: 0;
    }
    .dob-select {
        width: 32%;
        display: inline-block;
    }
}
</style>

<style lang="less" scoped>
.help-block {
    color: #e63f57;
}
</style>
